import React, { useEffect, useState } from 'react';

import { Breakpoints, Container } from '@vw-marketing/us-components';

import { Form } from './app/form';
import { Literature } from './app/literature/Literature';
import { Maintenance } from './app/maintenance/Maintenance';
import { MaintenanceContextProvider } from './context/MaintenanceContext';
import {
  OwnersLiteratureDocumentsData,
  MaintenanceSchedule,
} from './typings/general';
import { StyledAppContainer } from './styled';
import { useFeatureAppConfig } from './hooks/use-feature-app-config';
import { fetchApiConfig } from './fetch-data/fetch-api-config';
import { onVWBasicPageLoadEvent } from './tagging/tagging-helpers';
import { useTrackingManager } from './hooks/use-tracking-manager';

interface AppProps {
  baseUrl?: string;
}

export function App({ baseUrl }: AppProps) {
  const [literatureData, setLiteratureData] = useState<
    OwnersLiteratureDocumentsData[] | any[]
  >([]);
  const [maintenanceSchedule, setMaintenanceSchedule] =
    useState<MaintenanceSchedule | null>(null);
  const [apiConfig, setApiConfig] = useState<string>('');
  const trackingManager = useTrackingManager();
  
  const { mode } = useFeatureAppConfig();

  const hasMaintenanceData =
    maintenanceSchedule &&
    Object.keys(maintenanceSchedule.packages ?? {}).length > 0;

  useEffect(() => {
    onVWBasicPageLoadEvent(trackingManager, mode);
    fetchApiConfig(baseUrl).then((apiKey) => {
      setApiConfig(apiKey);
    });
  }, []);

  return (
    <MaintenanceContextProvider>
      <StyledAppContainer>
        {literatureData.length > 0 && mode === 'literature' && apiConfig ? (
          <Literature
            literatureData={literatureData}
            setLiteratureData={setLiteratureData}
            apiConfig={apiConfig}
          />
        ) : maintenanceSchedule && hasMaintenanceData && mode === 'maintenance' && apiConfig ? (
          <Maintenance
            maintenanceSchedule={maintenanceSchedule}
            setMaintenanceSchedule={setMaintenanceSchedule}
          />
        ) : (
          <Container
            padding={{
              top: {
                [Breakpoints.default]: 'static520',
                [Breakpoints.b560]: 'static600',
              },
              bottom: {
                [Breakpoints.default]: 'static520',
                [Breakpoints.b560]: 'static600',
              },
            }}
            stretchContent
          >
            <Form
              setLiteratureData={setLiteratureData}
              setMaintenanceSchedule={setMaintenanceSchedule}
              baseUrl={baseUrl}
              apiConfig={apiConfig}
            />
          </Container>
        )}
      </StyledAppContainer>
    </MaintenanceContextProvider>
  );
}
